module.exports = {
    location: "Umiestnenia",
    dispatching: "Dispečing"
}